export default [
  {
    text: 'Opção Inteligente',
    value: 'SMART_OPTION',
    method_types: 'method',
  },
  {
    text: 'Mais demorado',
    value: 'SLOWEST',
    method_types: 'method',
  },
  {
    text: 'Mais Barato (custo)',
    value: 'CHEAPEST',
    method_types: 'method',
  },
  {
    text: 'Mais Rápido',
    value: 'FASTEST',
    method_types: 'method',
  },
  {
    text: 'Mais barato (preço)',
    value: 'CHEAPEST_FINAL',
    method_types: 'method',
  },
  {
    text: 'Mais caro (custo)',
    value: 'MORE_EXPENSIVE',
    method_types: 'method',
  },
  {
    text: 'Mais caro (preço)',
    value: 'MORE_EXPENSIVE_FINAL',
    method_types: 'method',
  },
  {
    text: 'Método de entrega',
    value: 'DM',
    method_types: 'dm',
  },
  {
    text: 'Melhor',
    value: 'BEST',
    method_types: false,
  },
  {
    text: 'Pior',
    value: 'WORST',
    method_types: false,
  },
  {
    text: 'Todos',
    value: 'ALL',
    method_types: false,
  },
];



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-quote/features/quoting-return/enum/EnumConditionalCustomCondition.js